import {
  CREATE_BUSINESS,
  CREATE_SHIFT,
  CREATE_SHIFT_FAILED,
  CREATE_SHIFT_SUCCESS, LOGIN, LOGIN_FAILED, LOGIN_SUCCESS, LOGOUT,
  RECEIVE_BUSINESS,
  RECEIVE_JOBS,
  RECEIVE_MANAGERS,
  RECEIVE_SHIFTS, RECEIVE_USER,
  REQUEST_BUSINESS, REQUEST_BUSINESS_FAILED,
  REQUEST_JOBS,
  REQUEST_MANAGERS,
  REQUEST_SHIFTS,
  SET_TITLE
} from './actionTypes';
import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';

function business(state = {}, action) {
  switch (action.type) {
    case CREATE_BUSINESS:
      return {
        ...state,
        isFetching: true
      };
    case REQUEST_BUSINESS:
      return {
        ...state,
        isFetching: true
      };
    case REQUEST_BUSINESS_FAILED:
      return {
        ...state,
        isFetching: false,
      };
    case RECEIVE_BUSINESS:
      return {
        ...state,
        isFetching: false,
        item: action.item
      };
    case LOGOUT:
      return {};
    default:
      return state;
  }
}

function shifts(state = {}, action) {
  switch (action.type) {
    case REQUEST_SHIFTS:
      return {
        ...state,
        isFetching: true
      };
    case RECEIVE_SHIFTS:
      return {
        ...state,
        isFetching: false,
        items: action.items
      };
    case CREATE_SHIFT:
      return {
        ...state,
        isFetching: true
      };
    case CREATE_SHIFT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        items: state.items.concat(action.shift),
      };
    case CREATE_SHIFT_FAILED:
      return {
        ...state,
        isFetching: false
      };
    case LOGOUT:
      return {};
    default:
      return state;
  }
}

function jobs(state = {}, action) {
  switch (action.type) {
    case REQUEST_JOBS:
      return {
        ...state,
        isFetching: true
      };
    case RECEIVE_JOBS:
      return {
        ...state,
        isFetching: false,
        items: action.items
      };
    default:
      return state;
  }
}

function managers(state = {}, action) {
  switch (action.type) {
    case REQUEST_MANAGERS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_MANAGERS:
      return {
        ...state,
        isFetching: false,
        items: action.items
      };
    case LOGOUT:
      return {};
    default:
      return state;
  }
}

function app(state = {}, action) {
  switch (action.type) {
    case SET_TITLE:
      return {
        ...state,
        title: action.title
      };
    default:
      return state;
  }
}

function auth(state = {}, action) {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        loginInProgress: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loginInProgress: false,
        token: action.key,
      };
    case LOGIN_FAILED:
      return {
        ...state,
        loginInProgress: false,
      };
    case LOGOUT:
      return {};
    default:
      return state;
  }
}

function user(state = null, action) {
  switch (action.type) {
    case RECEIVE_USER:
      return action.user;
    case LOGOUT:
      return null;
    default:
      return state;
  }
}


const appReducers = combineReducers({
  business,
  shifts,
  jobs,
  app,
  auth,
  managers,
  user,
  form: formReducer
});

export default appReducers;



// WEBPACK FOOTER //
// ./src/state/reducers.js